module.exports = __webpack_public_path__ + "img/product-placeholder-34.748838a.png";